import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_PAYMENT_PRODUCTS_START,
  FETCH_PAYMENT_PRODUCTS_SUCCESS,
  FETCH_PAYMENT_PRODUCTS_FAILURE,
  ADD_PAYMENT_PRODUCTS_START,
  ADD_PAYMENT_PRODUCTS_SUCCESS,
  ADD_PAYMENT_PRODUCTS_FAILURE,
  FETCH_MERCHANT_FEES_REQUEST,
  FETCH_MERCHANT_FEES_SUCCESS,
  FETCH_MERCHANT_FEES_ERROR,
  FETCH_MERCHANT_TERMINALS_REQUEST,
  FETCH_MERCHANT_TERMINALS_SUCCESS,
  FETCH_MERCHANT_TERMINALS_ERROR,
} from './actions';

export const transformPaymentProduct = response => {
  return {
    id: response.id,
    name: response.payment_product_name,
    isVmd: response.payment_product_is_vmd,
    isAmex: response.payment_product_is_amex,
    isCardServices: response.payment_product_is_card_services,
    isDefault: response.payment_product_is_default,
  };
};

const transformPaymentProducts = response => {
  return { items: response.map(transformPaymentProduct) };
};

const fetchPaymentProductsReducer = createApiReducer(
  [
    FETCH_PAYMENT_PRODUCTS_START,
    FETCH_PAYMENT_PRODUCTS_SUCCESS,
    FETCH_PAYMENT_PRODUCTS_FAILURE,
  ],
  transformPaymentProducts,
  error => _.get(error, 'payload.response', 'unknown error')
);

const addPaymentProductReducer = createApiReducer(
  [
    ADD_PAYMENT_PRODUCTS_START,
    ADD_PAYMENT_PRODUCTS_SUCCESS,
    ADD_PAYMENT_PRODUCTS_FAILURE,
  ],
  (payload, state) => {
    const newProduct = transformPaymentProduct(payload);

    return {
      ...state.data,
      items: [...state.data.items, newProduct],
    };
  },
  error => transformPaymentProduct(_.get(error, 'payload.response', {}))
);

const products = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchPaymentProductsReducer,
  addPaymentProductReducer
);

// Fees reducer
const feesInitialState = {
  data: null,
  loading: false,
  error: null,
};

function feesReducer(state = feesInitialState, action) {
  switch (action.type) {
    case FETCH_MERCHANT_FEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MERCHANT_FEES_SUCCESS:
      return {
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_MERCHANT_FEES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Terminals reducer
const terminalsInitialState = {
  data: null,
  loading: false,
  error: null,
};

function terminalsReducer(state = terminalsInitialState, action) {
  switch (action.type) {
    case FETCH_MERCHANT_TERMINALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MERCHANT_TERMINALS_SUCCESS:
      return {
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_MERCHANT_TERMINALS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export const reducer = combineReducers({
  products,
  fees: feesReducer,
  terminals: terminalsReducer,
});
